var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"variableTable",attrs:{"selection":"","paging":false,"columns":_vm.variablesCol,"rows":_vm.variables,"rowSize":'lg'}})
}
var staticRenderFns = []

export { render, staticRenderFns }